import React from 'react';
import styled from 'styled-components';
import { useTheme } from './contexts/ThemeContext';

const LogoContainer = styled.footer<{hasWhiteBackground?: boolean}>`
  position: fixed;
  bottom: env(safe-area-inset-bottom);
  width: 100%;
  height: 50px;
    background: ${(props) => (props.hasWhiteBackground
    ? 'rgba(255, 255, 255, 1)'
    : 'rgba(0,0,0,0)')};  
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  backdrop-filter: blur(6px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
  z-index: 1000;

  > * {
    margin: 0 auto;
  }
`;

const LogoWrapper = styled.div<{maxWidth?: number | 'auto'}>`
  display: flex;
  justify-content: center;
  align-items: center;
    max-width: ${({ maxWidth }) => (!maxWidth ? '250px' : (maxWidth === 'auto' ? 'auto' : `${maxWidth}px`))};
  margin: 0 20px;
    
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
  }

  &:active {
    transform: scale(0.96);
  }
`;

const LogoFooter = () => {
  const { theme } = useTheme();

  return (
    <LogoContainer hasWhiteBackground={theme.logoFooterWhiteBG}>
      <LogoWrapper maxWidth={theme.logoFooterMaxWidth || 'auto'}>
        <img
          src={theme.logo}
          alt="Brand logo"
          draggable="false"
        />
      </LogoWrapper>
    </LogoContainer>
  );
};

export default LogoFooter;
